import styled from "react-emotion"
import PropTypes from "prop-types"

const TextArea = styled("textarea")`
    font-family: ${props => props.theme.fontFamily};
    font-size: ${props => props.theme.fontSize};
    background-color: ${props => props.theme.inputBackgroundColor};
    border-radius: ${props => props.theme.elementBorderRadius};
    padding: ${props => props.theme[props.padding || "small"]};
    border: ${props => props.theme.dividerThickness}px solid ${props => props.theme.outlineColor};

    &:focus {
        outline: none;
    }
`

TextArea.propTypes = {
    padding: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
}

export default TextArea



// WEBPACK FOOTER //
// ./src/ui/components/TextArea.js